"use client";

import { c as _c } from "react/compiler-runtime";
import { useMobileSearch } from "@/components/layout/mobile-search-context";
import { useIsMobile } from "@/hooks/use-mobile";
import { useScrollDirection } from "@/hooks/use-scroll-direction";
import { cn } from "@domainstack/ui/utils";
export function AppHeaderGrid(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    isOpen: isSearchOpen
  } = useMobileSearch();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      threshold: 15
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    direction,
    isPastThreshold
  } = useScrollDirection(t1);
  const isScrolledAway = isPastThreshold && direction === "down";
  const t2 = isPastThreshold ? "max-md:fixed" : "max-md:absolute";
  const t3 = isScrolledAway ? "transition-none max-md:-translate-y-full" : "transition-[translate]";
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = cn("group/header top-0 right-0 left-0 z-100 grid h-[var(--header-height)] items-center gap-4 px-4 md:sticky md:right-auto md:left-auto", "border-b border-black/15 bg-background/80 backdrop-blur dark:border-white/10", "grid-cols-[auto_1fr] duration-300 ease-out motion-reduce:transition-none md:grid-cols-[1fr_minmax(0,var(--container-2xl))_1fr]", "max-md:overflow-x-clip", t2, t3);
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children || $[5] !== isScrolledAway || $[6] !== isSearchOpen || $[7] !== t4) {
    t5 = <header data-search-open={isSearchOpen} data-scrolled-away={isScrolledAway} className={t4}>{children}</header>;
    $[4] = children;
    $[5] = isScrolledAway;
    $[6] = isSearchOpen;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="h-[var(--header-height)] md:hidden" aria-hidden={true} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <>{t5}{t6}</>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export function AppHeaderActions(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  const {
    isOpen: isSearchOpen
  } = useMobileSearch();
  const isMobile = useIsMobile();
  const isHidden = isMobile && isSearchOpen;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex h-full items-center justify-end gap-1.5 max-md:col-start-2 max-md:row-start-1", "transition-[opacity,translate] duration-200 ease-out motion-reduce:transition-none max-md:group-data-[search-open=true]/header:translate-x-4 max-md:group-data-[search-open=true]/header:opacity-0", "max-md:group-data-[search-open=true]/header:pointer-events-none");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = isHidden || undefined;
  let t3;
  if ($[1] !== children || $[2] !== t2) {
    t3 = <div className={t1} inert={t2}>{children}</div>;
    $[1] = children;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}